import React from 'react'
import { GalleryShow } from '../components/GalleryShow'

const Gallery = () => {
  return (
    <div><GalleryShow /></div>
  )
}

export default Gallery